export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      exact: true,

    },
    {
      name: 'User Manager',
      url: '/users',
      icon: 'fa fa-users',
      exact: true,
    },
    {
      name: 'Advertisement Manager',
      url: '/advertisements',
      icon: 'fa fa-picture-o',
      exact: true,
    },
    {
      name: 'Main Service Manager',
      url: '/main_services',
      icon: 'fa fa-wrench',
      exact: true,
    },
    {
      name: 'Service Manager',
      url: '/services',
      icon: 'fa fa-wrench',
      exact: true,
    },
    /*{
      name: 'Branchs Manager',
      url: '/stores',
      icon: 'fa fa-shopping-cart'
    },
    {
      name: 'Driver Manager',
      url: '/delivery-boys',
      icon: 'fa fa-motorcycle'
    },*/
    {
      name: 'Products Manager',
      url: '/items',
      icon: 'fa fa-cutlery',
      exact: true,
      children: [
        {
          name: 'Category Manager',
          url: '/items/categories',
          icon: 'fa fa-list',
          exact: true,
        },
        {
          name: 'Sub Category',
          url: '/items/sub-categories',
          icon: 'fa fa-list-alt',
          exact: true,
        },
        {
          name: 'Products',
          url: '/items/products',
          icon: 'fa fa-list',
          exact: true,
        },
        {
          name: 'Sell Products Listing',
          url: '/items/products/sell',
          icon: 'fa fa-list',
          exact: true,
        },
        /*{
          name: 'Occasions Manager',
          url: '/items/occasions',
          icon: 'fa fa-list'
        },
        {
          name: 'Sub Category',
          url: '/items/sub-categories',
          icon: 'fa fa-list-alt'
        },
        {
          name: 'Products Listing',
          url: '/items/products',
          icon: 'fa fa-cutlery',
        },*/
      ]
    },
    {
      name: 'Automotive manager',
      url: '/car',
      icon: 'fa fa-car',
      exact: true,
      children: [
        // {
        //   name: 'Category Manager',
        //   url: '/car/categories',
        //   icon: 'fa fa-list'
        // },
        {
          name: 'Brand',
          url: '/car/brands',
          icon: 'fa fa-list',
          exact: true,
        },
        {
          name: 'Model',
          url: '/car/models',
          icon: 'fa fa-medium',
          exact: true,
        },
        // {
        //   name: 'Color ',
        //   url: '/cars/color',
        //   icon: 'fa fa-medium'
        // },
        {
          name: 'Variant',
          url: '/car/variant',
          icon: 'fa fa-medium',
          exact: true,
        },
        {
          name: 'Fuel',
          url: '/fuel',
          icon: 'fa fa-medium',
          exact: true,
        },
        {
          name: 'Listing',
          url: '/cars',
          icon: 'fa fa-car',
          exact: true,
        },
        {
          name: 'Sell Listing',
          url: '/cars/sell',
          icon: 'fa fa-car',
          exact: true,
        },
      ]
    },
    {
      name: 'Dealer Shelf Manager',
      url: '/dealer/shelf',
      icon: 'fa fa-table'
    },
    {
      name: 'Feature Manager',
      url: '/feature',
      icon: 'fa fa-star'
    },
    /*{
      name: 'Orders',
      url: '/orders',
      icon: 'fa fa-shopping-cart',
      children: [
        {
          name: 'Current Order',
          url: '/orders/list',
          icon: 'fa fa-plus',
        },
        {
          name: 'Order History',
          url: '/orders/history',
          icon: 'fa fa-plus',
        }
      ]
    },
    {
      name: 'Manage Coupon',
      url: '/discount-code',
      icon: 'fa fa-cc'
    },*/
    {
      name: 'Post Manager',
      url: '/posts',
      icon: 'fa fa-sticky-note-o',
      children: [
        {
          name: 'Products',
          url: '/posts/product',
          icon: 'fa fa-product-hunt',
          exact: true,
        },
        {
          name: 'Car Post',
          url: '/posts/data',
          icon: 'fa fa-car',
          exact: true,
        }
      ]
    },
    /* {
      name: 'Post Manager',
      url: '/posts',
      icon: 'fa fa-sticky-note-o'
    }, */
    {
      name: 'Sold Manager',
      url: '/sold',
      icon: 'fa fa-shopping-cart',
      children: [
        {
          name: 'Product Sold',
          url: '/sold/products',
          icon: 'fa fa-product-hunt',
          exact: true,
        },
        {
          name: 'Car Sold',
          url: '/sold/data',
          icon: 'fa fa-car',
          exact: true,
        }
      ]
    },
    {
      name: 'Notifications Manager',
      url: '/notifications',
      icon: 'fa fa-bell'
    },
    {
      name: 'Banners Manager',
      url: '/banners',
      icon: 'fa fa-picture-o'
    },
    {
      name: 'Email Templates',
      url: '/email-templates',
      icon: 'fa fa-envelope'
    },
    {
      name: 'Content Manager',
      url: '/contents',
      icon: 'fa fa-file-text'
    },
    /*{
      name: 'Settings',
      url: '/settings',
      icon: 'fa fa-cogs'
    },*/

  ],
};
